export default __webpack_public_path__ + "static/media/loginLogo.7646f352.svg";